// frontend/src/encapsulation/components/ResultsPlot.jsx

import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

/**
 * Props:
 *   - data: Array<{ Time: number, Signal: number, fitted: number }>
 *   - title?: string
 *   - showLegend?: boolean  (default true)
 */
export default function ResultsPlot({
  data,
  title,
  showLegend = true,
  rawKey = "Signal",
  fitKey = "fitted"
}) {
  const fmt = num => (typeof num === "number" ? num.toFixed(2) : num);

  return (
    <div style={{ margin: "1rem 0" }}>
      {title && (
        <h3 style={{ fontSize: "1.125rem", marginBottom: "0.5rem" }}>
          {title}
        </h3>
      )}
      <div style={{ width: "100%", height: 250 }}>
        <ResponsiveContainer>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Time" tickFormatter={fmt} />
            <YAxis tickFormatter={fmt} />
            <Tooltip
              formatter={value => fmt(value)}
              labelFormatter={label => `Time: ${fmt(label)}`}
            />
            {showLegend && <Legend />}
            <Line
              type="monotone"
              dataKey={rawKey}
              name="Raw Signal"
              dot={false}
              stroke="#0084ff"
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey={fitKey}
              name="Gaussian Fit"
              dot={false}
              stroke="#ff7300"
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
